import React, { useState } from 'react';
import { Card, Modal } from "react-bootstrap";
import { TFunction, withTranslation } from 'react-i18next';
import Form from '../containers/form';
import "./form.scss";
import Button from '../controls/buttons/button';
import SubmitButton from '../controls/buttons/submitButton';
import { ReactComponent as IconTrashSVG } from "itd-common/assets/icons/trash.svg";
import { ReactComponent as IconFiltersSVG } from "itd-common/assets/icons/icon-filters.svg";
import { ReactComponent as IconCloseSVG } from "itd-common/assets/icons/close.svg";
import { UtilService } from '../../services/UtilService';
import { WebCache } from '../../services/WebCache';

interface IProps {
    header?: React.ReactElement,
    children: React.ReactElement,
    onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void,
    clear?: () => void,
    model?: any,
    hidden?: Boolean,
    t: TFunction
}

const FormFilter = ({ header, hidden, children, onSubmit, clear, model, t }: IProps) => {
    const [hiddenModal, setHiddenModal] = useState(true);
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (onSubmit) {
        hidden && setHiddenModal(true);
        onSubmit(event);
    }
    }

return (
    <div className={`filter-accordion form-filter ${UtilService.isMobilePlatform() && 'my-4'}`}>
        <>
            <Modal show={!hiddenModal} size='lg' scrollable={true} dialogClassName={WebCache.isPosnetAppUser() ? 'isPosnetAppUser' : ''}> 
                <div className='row'>
                    <div className='col-md-12 d-flex justify-content-end'>
                        <a {...(UtilService.isMobilePlatform() ? {}: { type: 'button'})} className='me-2 mt-5' onClick={()=> setHiddenModal(true)}>
                            <IconCloseSVG ></IconCloseSVG>
                        </a>
                    </div>
                </div>
                <div className='row scrollable-container mb-5 div-form-filter'>
                    <Form onSubmit={handleSubmit} model={model}>
                        <>
                            <div className='row filters-title'>
                                <h3 className='mb-1'>{t('filters')}</h3>
                                <p className='text-gray'>{t('elementsSelectedSearch')}</p>
                            </div>
                            <section className='d-flex aling-items-center ju1stify-content-center px-4'>
                                    {children}
                            </section>
                            <div className="row mt-5 mb-5 justify-content-end"> 
                                <div className="col-md-12 col-lg-7 d-flex justify-content-end clear-filter">
                                    { !clear ||
                                    <a{...(UtilService.isMobilePlatform() ? {}: { type: 'button' } )} className='fw-bold d-flex align-items-center me-4' onClick={clear}>
                                        {t('clear')} <IconTrashSVG className='ms-2'></IconTrashSVG>
                                    </a>
                                    }
                                    <SubmitButton label="query" className={`applyFilter m-0 me-3 ${UtilService.isMobilePlatform()?'submitNative':''}`}></SubmitButton>
                                </div>
                            </div>
                        </>
                    </Form>
                </div>
            </Modal>
            { hidden ? // si el parametro hidden viene true, se oculta los filtros y cuando se hace click en el icono. se muestran en un modal
                <>
                    {WebCache.isPosnetAppUser() 
                        ? <div className="col-md-10">
                            <Button noBlock noMargin onClick={() => setHiddenModal(false)} label='Filtros'></Button>
                        </div>
                        : 
                        <a
                            {...(UtilService.isMobilePlatform() && { type: 'button' } )}
                            onClick={() => setHiddenModal(false)}
                        >
                            <IconFiltersSVG></IconFiltersSVG>
                        </a>
                    }
                </>
                : 
                <div className="filter-accordion mb-4">
                    <Form onSubmit={handleSubmit} model={model}>
                    <>
                        {header}
                        {children}
                        <div className="row mt-5 justify-content-end"> 
                            <div className="col-md-12 col-lg-6 d-flex justify-content-end">
                                { !clear ||
                                <a {...(UtilService.isMobilePlatform() ? {}: { type: 'button' } )} className='fw-bold d-flex align-items-center pe-4' onClick={clear}>
                                    {t('clear')} <IconTrashSVG className='ps-1'></IconTrashSVG>
                                </a>
                                }
                                <SubmitButton className="applyFilter m-0" label="query"></SubmitButton>
                            </div>
                        </div>
                    </>
                    </Form>
                </div>
            }
        </>
        </div>
    );
};

export default withTranslation()(FormFilter);
